import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
    
    // Also ensure title is visible by removing any loading states
    // This helps with title update reliability
    const titleElement = document.querySelector('title');
    if (titleElement) {
      // Force a reflow to ensure the title updates
      void titleElement.offsetHeight;
    }
  }, [pathname]);

  return null;
}